export const PURCHASE_ORDER_APPROVAL_SETTINGS_ANCHOR_ID = 'purchase-order-approval-settings';

export const PURCHASE_ORDER_APPROVAL_SETTINGS_URL =
  `/app/settings/advanced#${PURCHASE_ORDER_APPROVAL_SETTINGS_ANCHOR_ID}`;
